import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { settingRoutingModule } from './settings-routing.module';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FillableFieldsComponent } from './fillable-fields/fillable-fields.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule, MatSelectTrigger } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { PeopleComponent } from './people/people.component';
import { CreateFieldComponent } from './create-field/create-field.component';
import { ApiEndPointsSettings } from './common/apiUrls/api-end-points-settings';
import { SettingService } from './services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/middleware/common/common.service';
import { AddFieldsVM,AddEditGroupVm, ReorderPositionVm } from 'src/app/viewModels/core/add-fields-vm';
import { AddFolderVM } from 'src/app/viewModels/core/add-folder-vm';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { EditFieldComponent } from './editField/edit-field.component';
import { OnlynumberDirective } from 'src/app/middleware/common/reusableclassesAndFunctions/number-d.directive';
import { NestableModule } from 'ngx-nestable';
import { MatRadioModule } from '@angular/material/radio';
import { EditCustomFieldComponent } from './edit-custom-field/edit-custom-field.component';
import { ManageSubtypeComponent } from './manage-subtype/manage-subtype.component';
import { ManageTagsComponent } from './manage-tags/manage-tags.component';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { MatCardModule } from '@angular/material/card';
import { AllNotificationsComponent } from './all-notifications/all-notifications.component';
import { RouterModule } from '@angular/router';
import { ManageTransactionRolesComponent } from './manage-transactionroles/manage-transactionroles.component';
import { ManageIntegrationComponent } from './manage-integration/manage-integration.component';
import { ManageRoomComponent } from './manage-room/manage-room.component';
import { AddRoomComponent } from './manage-room/add-room/add-room.component';
import { AddEquipmentComponent } from './manage-equipment/add-equipment/add-equipment.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import { ManageEquipmentComponent } from './manage-equipment/manage-equipment.component';
import { AddProcedureComponent } from './manage-procedure/add-procedure/add-procedure.component';
import { ManageProcedureComponent } from './manage-procedure/manage-procedure.component';
import {MatSliderModule} from '@angular/material/slider';
import { ManageSupplyComponent } from './manage-supply/manage-supply.component';
import { AddSupplyComponent } from './manage-supply/add-supply/add-supply.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { ManageFacilityComponent } from './manage-facility/manage-facility.component';
import { AddFacilityComponent } from './manage-facility/add-facility/add-facility.component';
import { AddFacilityRequestComponent } from './manage-facility/add-facility-request/add-facility-request.component';
import { FacilityFilterComponent } from './manage-facility/facility-filter/facility-filter.component';
import { ManageMonitoringComponent } from './monitoring/manage-monitoring/manage-monitoring.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ManageTemplateCategoryComponent } from './manage-templatecategory/manage-templatecategory.component';
import { ManageSharedRolesComponent } from './manage-sharedroles/manage-sharedroles.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { ManageTemplatesComponent } from './manage-templates/manage-templates.component';
import { ImportComponent } from './import/import.component';
import { MessageTemplatesComponent } from './mesage-templates/message-templates.component';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { MatSortModule } from '@angular/material/sort';
import { ManageTaskStatusComponent } from './manage-taskstatus/manage-taskstatus.component';
import { ManageTaskTemplatesComponent } from './manage-tasktemplates/manage-tasktemplates.component';
import { ThirdPartyApiBindingComponent } from './third-party-api-binding/third-party-api-binding.component';
import { PaychexComponent } from './third-party-api-binding/paychex/paychex.component';
import { ClipboardModule} from '@angular/cdk/clipboard';
import { ManageTaskCategoryComponent } from './manage-taskcategory/manage-taskcategory.component';
import { AddThirdPartyComponent } from './add-third-party/add-third-party.component';
import { ManageTemplateCategoryOrgComponent } from './manage-templatecategoryorg/manage-templatecategoryorg.component';
import { ManageSingleTaskTemplatesComponent } from './manage-singletasktemplates/manage-singletasktemplates.component';
import { ManageActivityStatusComponent } from './manage-activitystatus/manage-activitystatus.component';
import { ManageOCRTemplateCategoryComponent } from './manage-OcrTemplatecategory/manage-OcrTemplatecategory.component';
import { ManageOCRTemplateComponent } from './manage-OcrTemplate/manage-OcrTemplate.component';
import { ManageEmailTemplateComponent } from './manage-Emailtemplate/manage-Emailtemplate.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ManageQuestionTemplateCategoryComponent } from './manage-QuestionTemplatecategory/manage-QuestionTemplatecategory.component';
import { ManageQuestionTemplateComponent } from './manage-QuestionTemplate/manage-QuestionTemplate.component';
import { ManageFolderFormComponent } from './manage-folderForm/manage-folderForm.component';
import { MatTreeModule } from '@angular/material/tree';
import { ManageFolderFormsComponent } from './manage-folderForms/manage-folderForms.component';
import { ManageCustomInfoStatusComponent } from './manage-customInfostatus/manage-customInfostatus.component';
import { ManageAIAutomationComponent } from './manage-AIAutomationTemplates/manage-AIAutomationTemplates.component';
import { ManageAutomationProcessReportComponent } from './manage-AutomationProcessReport/manage-AutomationProcessReport.component';
import { managentacomorbidityComponent } from './manage-nta-comorbidity/managentacomorbidity.component';
import { ManageSystemPromptsTemplateComponent } from './manage-Systemprompt/manage-Systemprompt.component';
import { ManageSNFSetProcessComponent } from './manage-snfsetprocess/manage-snfsetprocess.component';

@NgModule({
  declarations: [SettingsComponent, FillableFieldsComponent, PeopleComponent,
    OnlynumberDirective, CreateFieldComponent, EditFieldComponent, EditCustomFieldComponent, ManageSubtypeComponent,
    ManageTransactionRolesComponent, ManageTagsComponent, SideNavigationComponent, AllNotificationsComponent, ManageIntegrationComponent, ManageRoomComponent, AddRoomComponent,
    ManageEquipmentComponent, AddEquipmentComponent, AddProcedureComponent, ManageProcedureComponent, ManageSupplyComponent, AddSupplyComponent, ManageFacilityComponent, 
    AddFacilityComponent, AddFacilityRequestComponent, FacilityFilterComponent, ManageMonitoringComponent,ManageTemplateCategoryComponent,ManageTemplateCategoryOrgComponent,
    ManageSharedRolesComponent,ManageTemplatesComponent, ImportComponent,MessageTemplatesComponent,LoginDetailsComponent,
    ManageTaskStatusComponent,ManageTaskTemplatesComponent, ThirdPartyApiBindingComponent, PaychexComponent,ManageTaskCategoryComponent, AddThirdPartyComponent
    ,ManageSingleTaskTemplatesComponent,ManageActivityStatusComponent,ManageOCRTemplateCategoryComponent,ManageOCRTemplateComponent,managentacomorbidityComponent,ManageSystemPromptsTemplateComponent,ManageEmailTemplateComponent,
    ManageQuestionTemplateCategoryComponent,ManageQuestionTemplateComponent,ManageFolderFormComponent,ManageFolderFormsComponent,
    ManageCustomInfoStatusComponent,ManageAIAutomationComponent,ManageAutomationProcessReportComponent,ManageSNFSetProcessComponent],
  imports: [
    ClipboardModule,
    CommonModule,
    settingRoutingModule,
    SharedModule,
    FlexLayoutModule,
    MatTabsModule,
    MatTableModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    DragDropModule,
    MatSlideToggleModule,
    MatListModule,
    NestableModule,
    MatSortModule,
    MatRadioModule,
    MatCardModule,
    RouterModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    CKEditorModule,
    MatTreeModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    AddFolderVM,
    ApiEndPointsSettings,
    SettingService,
    EncryptionService,
    ReusableClasses,
    StatusConstant,
    LoaderService,
    ToastrService,
    AddSubFolderVM,
    CommonService,
    AddFieldsVM,
    ReorderPositionVm,
    AddEditGroupVm,
    MultiselectVM,
    DatePipe,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
  ]
})
export class SettingsModule { }
